// @flow
import type { FSA } from 'types/redux';
import moment from 'moment';
import {
  SIMULATION_BOOKINGS_COMPLETE_EVENT,
  SIMULATION_BOOKINGS_TIMEOUT_EVENT,
  DRIVER_LOCATION_UPDATE_EVENT,
  SIMULATION_RESOURCE_CREATION_ERROR,
} from 'types/events';
import {
  simulationReportLoad,
  resourceCreationError,
} from 'actions/app';
import {
  batchDriverSetLocation,
} from 'actions/drivers';
import type {
  Location,
} from 'types/entities';
import type {
  EventData,
  SimulationReportEvent,
  DriverLocationUpdateEvent,
} from 'types/events';

import handleCohortEvent from '../../dashboard/cohort-events-handler';

export const emptyEvent: FSA = {
  type: '',
  payload: null,
};

function EventAccumulator() {
  let queue: { [string]: Location } = {};
  let last = new Date();

  this.add = function add(cohortID: string, driverID: string, location: Location): FSA {
    queue[driverID] = location;
    if (moment().diff(last, 'seconds') > 2) {
      const fsa = batchDriverSetLocation(cohortID, {
        ...queue,
      });

      queue = {};
      last = new Date();
      return fsa;
    }

    return emptyEvent;
  };
}

const evtAcct = new EventAccumulator();

export default function handleSimulationEvent(cohortID: string, eventData: EventData): FSA {
  const { type, params } = eventData;
  switch (type) {
    case SIMULATION_BOOKINGS_TIMEOUT_EVENT:
    case SIMULATION_BOOKINGS_COMPLETE_EVENT :
      {
        let timeout = false;
        if (type === SIMULATION_BOOKINGS_TIMEOUT_EVENT) {
          timeout = true;
        }
        const event: SimulationReportEvent = params;
        const { successfulRides, totalBookings, successRate, allocationRate,
        passengerIDs, driverIDs, errors, bookings } = event;
        return simulationReportLoad(successfulRides, totalBookings,
        successRate, allocationRate, passengerIDs, driverIDs, errors, timeout, bookings);
      }
    case DRIVER_LOCATION_UPDATE_EVENT:
      {
        const event: DriverLocationUpdateEvent = params;
        const { driverID, latitude, longitude } = event;
        const location: Location = [longitude, latitude];
        return evtAcct.add(cohortID, driverID, location);
      }
    case SIMULATION_RESOURCE_CREATION_ERROR:
      {
        return resourceCreationError();
      }
    default:
      break;
  }
  return handleCohortEvent(cohortID, eventData);
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/simulation-events-handler.js
 **/